// extracted by mini-css-extract-plugin
export default {"GPUDisable":"ZtIcrv8JgebIBS5D3okQ","fixMinHeight":"IYPK8L9pvqLpuK7P_t55","placeHolderShimmer":"NCTKa_9THNB3ePsGEGOx"};